import React from 'react';
import colors from '../../colors';
import { Party, Seat } from './styles';

export default ({ name, shortcut, id, senators }) => {
	return <Party title={name} data-vid={id}>
		<Seat style={{ backgroundColor: colors[id] || colors.default }}></Seat>
		{shortcut} ({senators})
	</Party>
}
